
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.container{
  display:grid;
  grid-template-columns:repeat(2, 1fr);
  grid-template-rows:1fr;
  grid-column-gap:var(--spacing-08);
  grid-column-gap:var(
    --sic-contact-block--default--large-spacing,
    var(--spacing-08)
  );
  grid-row-gap:0px;
}

.content{
  color:var(--sic-contact-block--default--default-color);
  color:var(
    --sic-contact-block--default-color,
    var(--sic-contact-block--default--default-color)
  );
}

.content a{
    color:var(--sic-contact-block--default-color);
    font-weight:bold;
  }

.content a:hover,
  .content a:focus-visible{
    color:var(--color-neutral-white);
    color:var(
      -sic-contact-block-link--text-color--hover,
      var(--color-neutral-white)
    );
    background-color:var(--color-primary-default);
    background-color:var(
      --sic-contact-block-link--bg-color--hover,
      var(--color-primary-default)
    );
  }

.cta-wrapper{
  margin-top:var(--spacing-04);
  margin-top:var(
    --sic-contact-block--default--default-spacing,
    var(--spacing-04)
  );
}
`;